import { FaBrain, FaLaptopCode, FaDesktop } from "react-icons/fa";

const services = [
  {
    Icon: FaLaptopCode,
    title: "Frontend Development",
    description:
      "Building responsive, performant interfaces with clean semantic markup. I craft pixel-perfect layouts with smooth interactions that delight users across all devices.",
    skills: ["HTML5", "CSS3", "JavaScript", "React", "Bootstrap", "Tailwind"],
  },
  {
    Icon: FaDesktop,
    title: "Web Design",
    description:
      "Designing clean, modern interfaces with a focus on usability and visual hierarchy. I translate ideas into intuitive designs using industry-standard tools.",
    skills: ["Figma", "Photoshop", "UI/UX", "Prototyping", "Typography"],
  },
  {
    Icon: FaBrain,
    title: "Problem Solving",
    description:
      "Tackling algorithmic challenges with analytical thinking and efficient code. Regular contest participation has sharpened my ability to break down complex problems.",
    skills: ["C++", "DSA", "Algorithms", "Codeforces", "CodeChef"],
  },
];

const Services = () => {
  return (
    <section className="service section-padding" id="service">
      <div className="container">
        {/* Section header */}
        <div
          className="text-center section-header"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="sec-label">What I Do</span>
          <h2 className="sec-title">My Services</h2>
          <div className="sec-line" />
        </div>

        <div className="service__grid">
          {services.map((svc, idx) => (
            <div
              key={svc.title}
              className="service__card"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={idx * 130}
            >
              <div className="service__icon">
                <svc.Icon />
              </div>
              <h3 className="service__title">{svc.title}</h3>
              <p className="service__description">{svc.description}</p>
              <div className="service__skills">
                {svc.skills.map((skill) => (
                  <span key={skill} className="service__skill">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
